module.exports = __webpack_public_path__ + "img/gq4.e2b4804d.png";